import type { SearchParams } from '@/server/searchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';

export const isLiveSearchByDate = (dateString: string | undefined): boolean => {
  const yyyymmddRegexp = /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/gm;
  return !!(dateString && dateString.match(yyyymmddRegexp) && !Number.isNaN(Date.parse(dateString)));
};

export const isFlexibleSearchByDate = (dateString: string | undefined): boolean => !isLiveSearchByDate(dateString);

export const shouldShowPropertyNameFilter = (searchParams: SearchParams | undefined): boolean =>
  !!searchParams && !!searchParams[URLParameters.DATE_FROM] && isLiveSearchByDate(searchParams[URLParameters.DATE_TO]);
